import { createContext } from 'react';

export interface RefreshContextType {
  isRefreshing: boolean;
  lastRefreshed: Date;
  refreshData: (additionalQueryKeys?: string[]) => Promise<void>;
  refreshInterval?: number;
  setRefreshInterval?: (interval: number) => void;
  isAutoRefreshEnabled?: boolean;
  toggleAutoRefresh?: () => void;
  refreshError?: string | null;
}

export const RefreshContext = createContext<RefreshContextType | undefined>(undefined);
